export default "__VITE_ASSET__BBbTb06X__"